import { render, staticRenderFns } from "./BuyGetDiscount.vue?vue&type=template&id=5c13b1f8&"
import script from "./BuyGetDiscount.vue?vue&type=script&lang=js&"
export * from "./BuyGetDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports